import { ActionCartRemoveProduct, ActionClearCart, CartState } from "@store/cart";
import { AppState } from "@store/state";
import { Component, OnInit, Input, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { SaleItem } from "@tendercuts/models";
import { Store as AppStore } from "@ngrx/store";
import { BasePage } from "src/app/base";

@Component({
  selector: "app-cart-display",
  templateUrl: "./cart-display.component.html",
  styleUrls: ["./cart-display.component.scss"],
})
export class CartDisplayComponent extends BasePage implements OnInit {
  @Input()
  readOnly = false;
  constructor(public store: AppStore<AppState>, public injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  get cartState(): Observable<CartState> {
    return this.store.select((state) => state.cartState);
  }

  /** Fn to get confirm before removing elite products from cart */
  presentAlert(item: SaleItem) {
    this.showConfirm(
      "Remove TenderCuts Elite",
      "You'll miss out on free delivery benefits for this order. Do you still want to remove ?",
      "",
      [],
      [
        {
          text: "Ok",
          handler: (data) => {
            this.removeProduct(item);
          },
        },
        {
          text: "Cancel",
          handler: (data) => {
            return;
          },
        },
      ],
      false
    );
  }

  /**
   *
   * @param item ie saleItem which contains subscription product to be removed
   * Removes the product and clear the
   */
  removeProduct(item: SaleItem) {
    this.store.dispatch(new ActionCartRemoveProduct(item.product));
    this.store.dispatch(new ActionClearCart());
    this.showToast("Elite Product Removed From Cart");
  }
}
